import {FC} from "react";
import {IAction} from "../../types/ApiTypes";
import Dropdown from "../ui/Dropdown";
import {HiDotsVertical} from "react-icons/hi";
import useApi from "../../hooks/useApi";
import {toast} from "react-hot-toast";
import axios from 'axios';
import handleToastError from "../../helpers/handleToastError";

interface Props {
    actions: IAction[];
    spaceId: string;
}

const SpaceActionsList: FC<Props> = (props) => {
    const {triggerAction} = useApi();

    const onActionTrigger = async (action: IAction) => {
        await toast.promise(triggerAction(action.id, props.spaceId),{
            loading: `Die Action ${action.name} wird getriggert`,
            success: `Die Action ${action.name} wurde getriggert`,
            error: (err) => handleToastError(err, "Das Space konnte nicht bearbeitet werden")
        });
    }

    return (
        <div className='absolute top-[19px] left-4 z-10'>
            <Dropdown items={props.actions.map(x => ({
                label: x.name,
                href: () => onActionTrigger(x)
            }))} triggerElement={(
                <span className='flex items-center'>
                    <HiDotsVertical className='text-2xl inline mr-1'/> Actions
                </span>
            )}/>
        </div>
    );
};

export default SpaceActionsList;